import React, { useEffect, useState } from "react";
import { TextInput, TextArea } from "../../Components/Inputs";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";
import init_requests from "../init_request";

const Edit = () => {
  const { id } = useParams();
  const [input, setInput] = useState(init_requests);
  const navigate = useNavigate();
  const request = useAxios();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getRequestDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getRequestDetails() {
    let res = await request({
      method: "get",
      url: `requests/single-request`,
      params: {
        id: parseInt(id),
      },
    });
    if (res === "error") return;

    const inputCpy = { ...init_requests };
    inputCpy.item_name.value = res?.item_name || "";
    inputCpy.quantity.value = res?.quantity?.toString() || "";
    inputCpy.description.value = res?.description || "";

    setInput(inputCpy);
  }

  const handleSubmit = async (data) => {
    setIsLoading(true);
    let res = await request({
      method: "PUT",
      url: `requests/update`,
      body: {
        id: parseInt(id),
        ...data,
      },
      show_loading: true,
      loadingFunc: setIsLoading,
    });
    if (res === "error") return;
    navigate("/dashboard/requests");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-xl font-semibold text-primary">
        Edit Request
      </h3>
      <div className="mt-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="item_name"
          validate={validate}
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="quantity"
          validate={validate}
        />
        <TextArea
          input={input}
          setInput={setInput}
          field="description"
          validate={validate}
        />
      </div>

      <div className="mt-4 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/requests")}>Back</Btn>
        <Btn onClick={handleValidation} disabled={isLoading}>
          {isLoading ? "updating..." : "Submit"}
        </Btn>
      </div>
    </div>
  );
};

export default Edit;
